import { ValidationObserver } from "vee-validate/dist/vee-validate.full";
import BForm from "@/components/singles/BForm/component.vue";
import EditableText from "@/components/singles/EditableText/component.vue";
import BModal from "@/components/singles/BModal/component.vue";

export default {
  name: "rule-management",
  components: {
    ValidationObserver,
    BForm,
    EditableText,
    BModal
  },
  props: [],
  data() {
    return {
      showModal: false,
      items: [],
      roles: [],
      form: {
        valid: false,
        inputs: [
          {
            name: "route",
            placeholder: "Route",
            type: "text",
            icon: "",
            validation: "required|regex:[a-zA-Z*]+[/][a-zA-Z*]+$",
            value: "",
            valid: false,
            focus: true
          }
        ],
        selects: [
          {
            validation: "required",
            itemsProp: "roles",
            nameProp: "name",
            title: "Roles",
            valid: false,
            items: [],
            selected: null
          },
          {
            validation: "required",
            itemsProp: "permissions",
            nameProp: "name",
            title: "Permission",
            valid: false,
            selected: null,
            items: [
              {
                name: "allow",
                value: true
              },
              {
                name: "deny",
                value: false
              }
            ]
          }
        ]
      },

      status: {
        message: null,
        show: false,
        saved: false,
        saving: false,
        timeout: 4000
      }
    };
  },
  computed: {
    orderedItems: function() {
      return _.orderBy(this.items, "role.name");
    }
  },
  mounted() {
    this.GetItems();
    this.GetRoles();
  },
  methods: {
    // Filter(items, uid) {
    //   if (uid == "") {
    //     return this.items;
    //   } else if (uid) {
    //     return this.$helpers.Filter(items, {
    //       role: {
    //         uid: uid
    //       }
    //     });
    //   } else {
    //     return items;
    //   }
    // },

    ShowStatus(message, timeout) {
      this.status = this.$helpers.ShowStatus(message, timeout, this.status);
    },

    async Save() {
      this.SaveBefore();

      let exists = this.items.find(
        x =>
          x.role.uid === this.form.selects[0].selected.uid &&
          x.rule.route === this.form.inputs[0].value
      );

      console.log(exists);

      if (exists) {
        this.$helpers.ShowStatus(
          `"${this.form.inputs[0].value}" already exists`,
          5000,
          "warning"
        );
        this.$store.state.saving = false;
      } else {
        await this.$helpers
          .PostApi("create/rule", {
            route: this.form.inputs[0].value,
            roleUID: this.form.selects[0].selected.uid,
            permitted: this.form.selects[1].selected.value
          })
          .then(res => {
            this.SaveSuccessful(res);
          })
          .catch(err => {
            this.SaveError(err);
          });
      }
    },

    SaveBefore() {
      this.$store.state.saving = true;
    },
    SaveSuccessful(res) {
      this.showModal = false;
      this.$store.state.saving = false;

      var newItem = res[0];

      this.$helpers.ShowNotification(
        '"' + newItem.rule.route + '" was added',
        "success",
        2000
      );
      this.items.push(newItem);
      this.$helpers.ClearForm(this.form);
    },
    SaveError(err) {
      this.$store.state.saving = false;
      this.$helpers.ShowNotification("Failed.", "danger", null);
      console.log(err);
    },

    Delete(item) {
      this.$store.state.deleting = true;

      this.$helpers
        .PostApi("delete/rule", {
          roleUID: item.role.uid,
          ruleUID: item.rule.uid
        })
        .then(res => {
          this.$helpers.RemoveFromArray(this.items, {
            rule: {
              uid: item.rule.uid
            }
          });

          this.$helpers.ShowNotification(
            '"' + item.role.name + ": " + item.rule.route + '" was deleted',
            "success",
            2000
          );
          this.$store.state.deleting = false;
        })
        .catch(err => {
          this.$store.state.deleting = false;
          console.log(err);
        });
    },

    GetItemsFromProperty(prop) {
      return this[prop];
    },

    async GetItems() {
      this.$helpers
        .PostApi("get/rules", {})
        .then(res => {
          this.items = res;
        })
        .catch(err => {
          console.log(err);
        });
    },

    async GetRoles() {
      this.$helpers
        .PostApi("get/roles", {})
        .then(res => {
          this.roles = res[0];
          this.form.selects[0].items = this.roles;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
